import RolePlaySubmission from '../components/role-play-submission';

export default class RolePlaySubmissionReactCtrl {
  /* @ngInject */
  constructor(
    $scope,
    StateManager,
  ) {
    $scope.StateManager = StateManager;
    $scope.RolePlaySubmission = RolePlaySubmission;
  }
}
